import React from 'react';
import CsvImportPageView from '../../../../Common/PageViews/CsvImport/Components/CsvImportPageView.jsx'

class RatesImportPageView extends React.Component {
    render() {
        const notesOnCompletion = [
            <li key="previous changes">
                <a target="_blank" rel="noopener noreferrer" href="/App/Rates/RateCard/Audit">View all previous changes to rates (audit).</a>
            </li>,
            <li key="recalculate">
                <a href="/Online/InvoiceLineSearch.aspx" onMouseUp={ this.registerLinkClicked }>Recalculate a consignment using the new rates.</a>
            </li>
        ];
        return <CsvImportPageView
            apiFunctionName="importRatesFromCsv"
            nameOfObjectToImport="rates"
            exportUrl="/App/Rates/RateCard"
            exportPageName="View rates"
            sampleCsvFile='Rate card type,Charge type,Customer,Carrier,Supplier,From zone,To zone,Rate product,Effective from date (including),Effective to date (including),Minimum,Maximum,Unit of measure,Charge per,Tier from (including),Tier to (excluding),Rate,Currency,Sold to,Order line rate product'
            helpUrl="https://support.ecargo.co.nz/hc/en-us/articles/360000691775-Importing-and-updating-rates"
            postImportViewCaption="View the rates you just loaded."
            viewUrl="/App/Rates/RateCard"
            notesOnCompletion={ notesOnCompletion }
        />
    }
}

export default RatesImportPageView;
